import i18n from '../i18n'
import {getSelection} from '../../api/fichier'
import {notify} from "../../components/tools/Notification";

const state = {
    discovered: false,
    fichiers: [],
    fichiersData: []
}

const getters = {
    selectionFichiers (state) {
        return state.fichiers
    },
    selectionFichiersData (state) {
        return state.fichiersData
    },
    discoveredStatus (state) {
        return state.discovered
    }
}

const actions = {
    updateSelection ({ state, commit }, newfichier) {
        const selectionItem = state.fichiers.find(fichierid => fichierid === newfichier.id)
        // si le fichier n'est pas dans la sélection
        if (!selectionItem) {
            commit('pushFichierToSelection', { fichier: newfichier })
            return true
        } else {
            commit('removeFichierFromSelection', { fichier: newfichier })
            return false
        }
    },
    inSelection ({state, commit}, id) {
        return state.fichiers.find(fichierid => fichierid === id);
    },
    loadDataSelection ({ state, commit }) {
        if (!state.fichiers.length) return;
        getSelection({fichiers: state.fichiers})
            .then( (data) => {
                commit('updateDataSelection', { data: data })
            })
    },
    updateDiscovered ({ commit }, flag) {
        commit('updateDiscovered', { flag: flag })
    }
}

const mutations = {
    pushFichierToSelection (state, { fichier }) {
        state.fichiers.push(fichier.id)
        state.fichiersData.push(fichier)
        notify( i18n.t('Fichier ajouté à la sélection'), {type:'success',size:'small',timeBeforeClose:1500})
    },
    removeFichierFromSelection (state, { fichier }) {
        state.fichiers = state.fichiers.filter(f => f !== fichier.id)
        state.fichiersData = state.fichiersData.filter(f => f.id !== fichier.id)
        notify( i18n.t('Fichier retiré à la sélection'), {type:'info',size:'small',timeBeforeClose:1500})
    },
    updateDataSelection (state, { data }) {
        state.fichiersData = data
    },
    updateDiscovered (state, { flag }) {
        state.discovered = flag
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
